import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BerthPlan from '@/components/blocks/berth-plan/berth-plan';
import BerthPlanViewToggle from '@/components/blocks/berth-plan/berth-plan-view-toggle';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SimulationShipVisitsTable } from '@/routes/(app)/(scenarios)/(simulation)/components/simulation-ship-visits-table';
import { SimulationRunShipVisit } from '@/routes/(app)/(scenarios)/(simulation)/simulation.types';

interface SimulationShipVisitsCardProps {
  shipVisits: Array<SimulationRunShipVisit>;
  cutoffMs?: number;
}

/** Predicted ship visits as a read-only Berth Plan or a table. */
export const SimulationShipVisitsCard: FC<SimulationShipVisitsCardProps> = ({
  shipVisits,
  cutoffMs,
}) => {
  const { t } = useTranslation();
  const [isTableView, setIsTableView] = useState(false);
  const [selectedVisitId, setSelectedVisitId] = useState<string | null>(null);

  return (
    <Card className='col-span-full'>
      <CardHeader className='flex flex-row flex-wrap items-center justify-between gap-2 py-4'>
        <CardTitle className='text-base'>
          {t('simulation.predictedShipVisits.title')}
        </CardTitle>
        <BerthPlanViewToggle
          isTableView={isTableView}
          onTableViewChange={setIsTableView}
        />
      </CardHeader>
      <CardContent>
        {isTableView ? (
          <SimulationShipVisitsTable shipVisits={shipVisits} />
        ) : (
          // The page scrolls, so the plan gets a fixed height to fill.
          <div className='flex h-[640px] flex-col'>
            <BerthPlan
              visits={shipVisits}
              cutoffMs={cutoffMs}
              selectedVisitId={selectedVisitId}
              onSelectVisit={setSelectedVisitId}
              onDeselect={() => {
                setSelectedVisitId(null);
              }}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};
